export default {
    ca: {
        title: 'Actualitzar contrasenya',
        emailValidation: 'L\'email és obligatori i ha de ser vàlid',
        emailPlaceholder: 'Correu',
        passwordPlaceholder: 'Contrasenya',
        cofirmPsswPlaceholder: 'Confirmar contrasenya',
        passValidation: 'La contrasenya ha de tenir almenys 5 caràcters',
        passEqualValidation: 'La confirmació de la contrasenya no coincideix',
        titleErrorRenovar: 'Error renovar contrasenya',
        messageErrorRenovar: 'L\'usuari no existeix',
        titleOkRenovar: 'S\'ha renovat la contrasenya',
        messageOkRenovar: 'La contrasenya s\'ha actualitzat',
    },
    es: {
        title: 'Actualizar contraseña',
        emailValidation: 'El email es obligatorio y debe ser válido',
        emailPlaceholder: 'Correo',
        passwordPlaceholder: 'Contraseña',
        cofirmPsswPlaceholder: 'Confirmar contraseña',
        passValidation: 'La contraseña debe tener al menos 5 caracteres',
        passEqualValidation: 'La confirmación de la contraseña no coincide',
        titleErrorRenovar: 'Error renovar contraseña',
        messageErrorRenovar: 'El usuario no existe',
        titleOkRenovar: 'Se ha renovado la contraseña',
        messageOkRenovar: 'La contraseña se ha actualizado',
    },
    en: {
        title: 'Update password',
        emailValidation: 'Email is mandatory and must be valid',
        emailPlaceholder: 'Email',
        passwordPlaceholder: 'Password',
        cofirmPsswPlaceholder: 'Confirm password',
        passValidation: 'The password must have at least 5 characters',
        passEqualValidation: 'Password verification mismatch',
        titleErrorRenovar: 'Error occurred changing password',
        messageErrorRenovar: 'User does not exist',
        titleOkRenovar: 'Password updated',
        messageOkRenovar: 'Password was updated succesfully',
    },
};



// WEBPACK FOOTER //
// ./src/renovar/renovar-translations.js